import React, { useEffect, useState } from 'react'
import { Wrapper } from './styles'
import { WHATS_NEW_FEATURES, formatDaysAgo, getDaysSinceLaunch, getUnreadCount } from 'src/helpers/whatsNew'

// The latest launches, in the left sidebar. Launches the owner has not opened yet show as a notification badge
export default function WhatsNewPanel() {
  const [modalOpen, setModalOpen] = useState(false)
  const [unreadCount, setUnreadCount] = useState(() => getUnreadCount(WHATS_NEW_FEATURES))

  useEffect(() => {
    const followModal = (e: Event) => {
      const detail = (e as CustomEvent).detail
      setModalOpen(!!detail?.isOpen)
      // The modal marks everything seen when it opens, wherever it was opened from
      if (detail?.isOpen) {
        setUnreadCount(0)
      }
    }
    window.addEventListener('whats-new-modal:change', followModal)
    return () => window.removeEventListener('whats-new-modal:change', followModal)
  }, [])

  const days = getDaysSinceLaunch(WHATS_NEW_FEATURES[0].launchedAt)
  // "20 de noutăți": from 20 up, Romanian puts "de" before the noun
  const unreadTitle =
    unreadCount === 1 ? 'O noutate necitită' : `${unreadCount}${unreadCount >= 20 ? ' de' : ''} noutăți necitite`

  return (
    <Wrapper $isFaded={modalOpen}>
      {unreadCount > 0 && (
        <span className="unread-badge" title={unreadTitle}>
          {unreadCount}
        </span>
      )}
      <h3 className="title">Ce e nou în MeniuDigital?</h3>
      <p className="launch-age">Ultimele noutăți lansate {days <= 10 ? <b>{formatDaysAgo(days)}</b> : formatDaysAgo(days)}</p>
      <button type="button" className="cta" onClick={() => window.openWhatsNewModal()}>
        Vezi noutățile
      </button>
    </Wrapper>
  )
}
